"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tv = void 0;
const tailwind_variants_1 = require("tailwind-variants");
exports.tv = (0, tailwind_variants_1.createTV)({
  twMergeConfig: {
    theme: {
      borderWidth: ['sm', 'md', 'lg']
    }
  }
});
